import React from "react";
import { Button } from "@/components/ui/button";
import { useDriveUpload } from "@/lib/useDriveUpload";

// Pre Orders waiting for photos: pick the customer's photos (saved from the
// email) → they land in Drive under PO-xxxx (folder auto-created) and the order
// is marked Photos Received.
export function PreorderPhotoUploadButton({ order, size = "sm", className = "", label = "📤 Upload Photos" }) {
  const inputRef = React.useRef(null);
  const upload = useDriveUpload(order.id, { kind: "customer" });
  return (
    <span className="inline-flex" onClick={(e) => e.stopPropagation()} onPointerDown={(e) => e.stopPropagation()}>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,video/*,application/pdf"
        multiple
        className="hidden"
        data-testid={`preorder-upload-input-${order.id}`}
        onChange={(e) => {
          const files = Array.from(e.target.files || []);
          if (files.length) upload.mutate(files);
          e.target.value = "";
        }}
      />
      <Button
        size={size}
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={upload.isPending}
        data-testid={`preorder-upload-btn-${order.id}`}
        className={`bg-sky-600 hover:bg-sky-700 text-white font-semibold shadow-sm ${className}`}
        title={`Upload the customer's photos to Drive › ${order.po_number} (folder is created if missing) and mark Photos Received`}
      >
        {upload.isPending ? "Uploading…" : label}
      </Button>
    </span>
  );
}
